import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Dots = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <circle cx="5.5" cy="10" r="1.25" fill="currentColor" />;
    t1 = <circle cx="10" cy="10" r="1.25" fill="currentColor" />;
    t2 = <circle cx="14.5" cy="10" r="1.25" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Dots;